import React, { ComponentType, CSSProperties, FC, HTMLAttributes, ReactNode } from 'react';
import { WithSpacingProps } from 'ia-react-core/~/hocs/grid/withSpacing';

export interface SpacingProps extends WithSpacingProps, HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  /** @ignore */
  style?: CSSProperties;
  /** Define a custom element type */
  as?: string | ComponentType<any>;
  /** Add a background and outine to help visually identify the element */
  debug?: boolean;
}

const SpacingDefaultProps = {
  as: 'div',
};

/**
 * @since 0.15.0
 * @see See the styleguide's [grid standard](/Styleguide/Grid)
 * @mode developer
 */
const Spacing: FC<SpacingProps> = ({ as, debug, style, ...props }) => {
  const newStyles: CSSProperties = { ...style };

  if (debug) {
    newStyles.outline = '1px solid silver';
    newStyles.background = 'rgba(0,0,0,.05)';
  }

  return React.createElement(as, { ...props, style: newStyles });
};

Spacing.defaultProps = SpacingDefaultProps;

export default Spacing;
